import myAccountApi from "@/service/modules/myAccountApi";
import styles from "@/styles/checkout.module.scss"
import { Button } from "antd";
import { useEffect, useState } from "react";
import AddressForm from "./AddressForm"
import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { updateUserInfo } from '@/store/slices/userInfoSlice';
import { useDispatch } from "react-redux"
import { AppDispatch } from '@/store/store';
interface propsVoid {
  email: string;
  customerID?: string | number;
  billingAddressID?: number
  addressID?: number
  checkout: Function
  [key: string]: any;
}

export default function GuestCheckout({ email, addressID, billingAddressID, checkout }: propsVoid) {
  const dispatch: AppDispatch = useDispatch();
  const [shippingAddress, setShippingAddress] = useState<any>({})
  const [billingAddress, setBillingAddress] = useState<any>({})

  const [showAddressForm, setShowAddressForm] = useState<boolean>(true)
  const [editType, setEditType] = useState<'shipping' | 'billing'>("shipping")
  const [addressList, setAddressList] = useState<any[]>([])
  const [defaultFormData, setDefaultFormData] = useState<any>({})
  const userInfo = useSelector((state: RootState) => state.userInfo.data);


  const setAddressInfo = (shippingAddress: any, billingAddress: any) => {
    const { billingAddressID, addressID } = userInfo
    if (shippingAddress) {
      setShippingAddress(shippingAddress)
      let userInfoParams: any = { ...userInfo, addressID: shippingAddress.addressID }
      if (!addressID) {
        // 当me接口没有默认地址时，默认地址就是收货地址
        setBillingAddress(shippingAddress)
        userInfoParams.billingAddressID = shippingAddress.addressID
      }
      // 更新store里面默认地址ID
      dispatch(updateUserInfo(userInfoParams))
    }
    if (billingAddress) {
      setBillingAddress(billingAddress)
      let userInfoParams: any = { ...userInfo, billingAddressID: billingAddress.addressID }
      if (!billingAddressID) {
        // 当me接口没有默认地址时，默认地址就是收货地址
        setShippingAddress(billingAddress)
        userInfoParams.addressID = billingAddress.addressID
      }
      // 更新store里面默认地址ID
      dispatch(updateUserInfo(userInfoParams))
    }
    if (shippingAddress || billingAddress) {
      setShowAddressForm(false)
    }
  }

  const changeAddress = (editType: 'shipping' | 'billing', formData: any) => {

    setEditType(editType)
    setShowAddressForm(true)
    setDefaultFormData({ ...formData, formTime: new Date().getTime() })
  }

  useEffect(() => {
    getCustomersAddresses()
  }, [])

  const getCustomersAddresses = async () => {
    try {
      let res = await myAccountApi.customerAddresses()
      if (res.data) {
        const addressList = res.data
        setAddressList(addressList)
        if (addressID && billingAddressID) {
          const shippingAddress = addressList.find((item: any) => item.addressID === addressID)
          const billingAddress = addressList.find((item: any) => item.addressID === billingAddressID)

          setAddressInfo(shippingAddress, billingAddress)
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  // 成功添加地址
  const successAddress = async (addressID: number | string, bothChange?: boolean) => {
    try {
      // 获取最新的地址列表拿到选中的那个
      let res = await myAccountApi.customerAddresses()
      const addressList = res.data
      setAddressList(addressList)
      const addressItem = addressList.find((item: any) => item.addressID === addressID)
      switch (editType) {
        case 'billing':
          setAddressInfo(null, addressItem)
          break
        case 'shipping':
          setAddressInfo(addressItem, null)
          break
      }
      if (bothChange) setAddressInfo(addressItem, addressItem)
      checkout()
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className={styles['checkout-user-info']}>
      <div className={styles['checkout-step']}>
        <div className={styles['checkout-step-item']}>
          <div className={styles['stepTitle']}>1.Your Email <span className={styles['desc']}>(to send your order comfirmation)*</span></div>
          <div className={styles['username-box']}>
            {email}
          </div>
        </div>
        <div className={styles['checkout-step-item']}>
          <div className={styles['stepTitle']}>2.Your Address</div>
          {
            !showAddressForm
            &&
            <>
              <div className={styles['stepSubTitle']}>{`Our parcels need to be received and signed off so if you won't be home during delivery hours.`}</div>
              <div className={styles['stepSubTitle']}>{`Crazysales suggests you use a work address or ensure someone is home to receive your parcel(s)!`}</div>
            </>
          }
          <div style={{ display: showAddressForm ? 'block' : 'none' }}>
            <AddressForm 
              addressList={addressList} 
              editType={editType} 
              address={null} 
              success={successAddress} 
              cancel={() => { 
                setShowAddressForm(false) 
              }} 
              type="edit" 
              defaultFormData={defaultFormData} 
              setAddressInfo={setAddressInfo} 
              canEdit={true} 
            />
          </div>
          <div className={styles['address-info-box']} style={{ display: showAddressForm ? 'none' : 'flex' }}>
            <div className={styles['address-info-item']}>
              <div className={styles['address-info-item-title']}>Shipping Address</div>
              <div className={`${styles['address-info-item-line']} ${styles['title-line']}`}>
                <div className={styles['address-info-item-line——label']}>{shippingAddress.firstName}</div>
                <div className={styles['address-info-item-line——val']}>{shippingAddress.lastName}</div>
              </div>
              <div className={styles['address-info-item-line']}>
                <div className={styles['address-info-item-line——label']}>{shippingAddress.address}</div>
                <div className={styles['address-info-item-line——val']}>{shippingAddress.address1}</div>
              </div>
              <div className={styles['address-info-item-line']}>
                <div className={styles['address-info-item-line——label']}>{shippingAddress.city}</div>
                <div className={styles['address-info-item-line——val']}>{shippingAddress.state}</div>
                <div className={styles['address-info-item-line——val']}>{shippingAddress.postCode}</div>
              </div>
              <div className={styles['address-info-item-line']}>
                <div className={styles['address-info-item-line——label']}>AUSTRALIA</div>
              </div>
              <div className={`${styles['address-info-item-line']} ${styles['change-address-line']}`}>
                <div className={styles['address-info-item-line——label']}>Phone</div>
                <div className={styles['address-info-item-line——val']}>{shippingAddress.phone}</div>
                <Button className={styles['change-address']} size="middle" ghost onClick={() => { changeAddress("shipping", shippingAddress) }}>Change Address</Button>
              </div>
            </div>


            <div className={styles['address-info-item']}>
              <div className={styles['address-info-item-title']}>Billing Address</div>
              <div className={`${styles['address-info-item-line']} ${styles['title-line']}`}>
                <div className={styles['address-info-item-line——label']}>{billingAddress.firstName}</div>
                <div className={styles['address-info-item-line——val']}>{billingAddress.lastName}</div>
              </div>
              <div className={styles['address-info-item-line']}>
                <div className={styles['address-info-item-line——label']}>{billingAddress.address}</div>
                <div className={styles['address-info-item-line——val']}>{billingAddress.address1}</div>
              </div>
              <div className={styles['address-info-item-line']}>
                <div className={styles['address-info-item-line——label']}>{billingAddress.city}</div>
                <div className={styles['address-info-item-line——val']}>{billingAddress.state}</div>
                <div className={styles['address-info-item-line——val']}>{billingAddress.postCode}</div>
              </div>
              <div className={styles['address-info-item-line']}>
                <div className={styles['address-info-item-line——label']}>AUSTRALIA</div>
              </div>
              <div className={`${styles['address-info-item-line']} ${styles['change-address-line']}`}>
                <div className={styles['address-info-item-line——label']}>Phone</div>
                <div className={styles['address-info-item-line——val']}>{billingAddress.phone}</div>
                <Button className={styles['change-address']} size="middle" ghost onClick={() => { changeAddress("billing", billingAddress) }}>Change Address</Button>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  )
}